import axios from 'axios';
import getAffiliateId from '../utils/get_affiliate_id';
import axiosClient from './axios-client';
import env from '../utils/env';

const URL = '/wp-admin/admin-ajax.php';
const affiliate_id = getAffiliateId();

const profileApi = {
  uploadPhoto: async (file, affID = affiliate_id) => {
    const data = new FormData();
    data.append('action', 'file_upload');
    data.append('affiliate_id', affiliate_id || affID);
    data.append('file', file);
    const response = await axiosClient.post(URL, data);
    return response;
  },
  getAffiliateById: async (affID = affiliate_id) => {
    const config = env();
    const response = await axios.get(`${config.serverAPI}/e/vn_affiliate_program/${affiliate_id || affID}`);
    return response;
  },
  updateAffiliateProfile: async (profile, affID = affiliate_id) => {
    const profileUpdated = {
      affiliate_id: +affiliate_id || +affID,
      ...profile
    }
    const data = new FormData();
    data.append('action', 'affiliate_dashboard');
    data.append('affiliate_id', affiliate_id);
    data.append('profile', JSON.stringify(profileUpdated));
    const response = await axiosClient.post(URL, data);
    return response;
  }
}

export default profileApi;
